import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable, Subject } from 'rxjs';

import { environment } from 'environments/environment';

import { IPaginatedListViewSearchModel, KeyValuePairModel, PaginatedModel } from '../models/common.models';
import {
  GetCaseFilters,
  IContainerDetailsModel,
  IUpdateContainerModel,
  IWineBottleInCaseListItemModel,
  IWineContainerListItemModel,
} from '../models/container.models';
import { FilterParameterService } from './filter-parameter.service';
import { FilterState } from './filter-state.service';

@Injectable({
  providedIn: 'root',
})
export class ContainerService {
  private searchEvent = new Subject<any>();

  searchEvent$ = this.searchEvent.asObservable();

  private get baseApiUrl(): string {
    return environment.storageManagementUrl;
  }

  constructor(
    private http: HttpClient,
    private filterParameterService: FilterParameterService,
  ) {}

  getContainersV1(
    searchModel: IPaginatedListViewSearchModel,
    filters?: FilterState[],
  ): Observable<PaginatedModel<IWineContainerListItemModel>> {
    const url = `${this.baseApiUrl}/v1/WineContainer`;
    let params = new HttpParams().appendAll({
      filterText: searchModel.searchText,
      orderByColumn: searchModel.orderByColumn,
      orderByDirection: searchModel.orderByDirection,
      page: searchModel.page.toString(),
      pageSize: searchModel.pageSize.toString(),
    });

    params = this.filterParameterService.getFilterParametersWithIndividualDateParams(params, filters);

    return this.http.get<PaginatedModel<IWineContainerListItemModel>>(url, {
      params,
    });
  }

  getContainerDetailsV1(id: number): Observable<IContainerDetailsModel> {
    const url = `${this.baseApiUrl}/v1/WineContainer/${id}`;
    return this.http.get<IContainerDetailsModel>(url, {});
  }

  setContainerStatusV1(id: number, status: boolean): Observable<any> {
    const url = `${this.baseApiUrl}/v1/WineContainer/${id}/capacitystatus`;
    return this.http.put<any>(url, { IsFull: status });
  }

  getContainerSummaryByLabelCodeV1(labelCode: string): Observable<IContainerDetailsModel> {
    const url = `${this.baseApiUrl}/V1/WineContainer/${labelCode}`;
    return this.http.get<IContainerDetailsModel>(url);
  }

  getBottlesInContainerV1(id: number): Observable<IWineBottleInCaseListItemModel[]> {
    const url = `${this.baseApiUrl}/v1/WineContainer/${id}/bottles`;
    return this.http.get<IWineBottleInCaseListItemModel[]>(url, {});
  }

  updateContainerV1(id: number, container: IUpdateContainerModel): Observable<void> {
    const url = `${this.baseApiUrl}/v1/WineContainer/${id}`;
    return this.http.put<void>(url, container);
  }

  getContainerTypes(filterText: string): Observable<KeyValuePairModel<number>[]> {
    const url = `${this.baseApiUrl}/v1/WineContainer/types`;
    const params = new HttpParams().append('filterText', filterText);
    return this.http.get<KeyValuePairModel<number>[]>(url, { params });
  }

  getContainerFilters(): Observable<GetCaseFilters> {
    const url = `${this.baseApiUrl}/v1/WineContainer/filters`;
    return this.http.get<GetCaseFilters>(url);
  }
}
